import { IFilter } from "entities/HelpersModel"

export enum AccessLevelEnum {
    NoAccess,
    Read,
    ReadWrite,
    FullAccess
}

export interface ICategorySecurity {
    categoryId: string,
    userId?: string,
    userGroupId?: string,
    accessLevel: AccessLevelEnum
}
export interface ICategorySecurityGet extends ICategorySecurity {
    userFullName?: string,
    userGroupName?: string,
}

export interface ICategorySecurityFilter extends IFilter {
}
